namespace $.$$ {

	export class $shm_projects_catalog extends $.$shm_projects_catalog {

		projects() {
			const priority = [
				'shared-modules',
				'hitalama',
				'projects',
				'monitoring-plus',
				'monitoring-plus-clean',
			]
			return this.$.$shm_projects_data.records()
				.filter( project => !project.archived )
				.map( ( project, index )=> ({ project, index }) )
				.sort( ( left, right )=> {
					const left_priority = priority.indexOf( left.project.id )
					const right_priority = priority.indexOf( right.project.id )
					if( left_priority < 0 && right_priority < 0 ) return left.index - right.index
					if( left_priority < 0 ) return 1
					if( right_priority < 0 ) return -1
					return left_priority - right_priority
				} )
				.map( item => item.project )
		}

		project_id( id: string ) {
			return id
		}

		project_selected() {
			const id = this.$.$mol_state_arg.value( 'project' ) ?? ''
			return this.projects().some( project => project.id === id ) ? id : ''
		}

		projects_filtered() {
			const filter = this.filter().trim().toLowerCase()
			if( !filter ) return this.projects()
			const matched = new Set( this.projects()
				.filter( project => project.title.toLowerCase().includes( filter ) )
				.map( project => project.id ) )
			for( const project of this.projects() ) {
				if( !matched.has( project.id ) ) continue
				for( let parent = this.project_parent( project.id ); parent; parent = this.project_parent( parent.id ) ) matched.add( parent.id )
			}
			return this.projects().filter( project => matched.has( project.id ) )
		}

		project_parent( id: string ) {
			const parent = this.$.$shm_projects_data.record( id )?.parent_id
			return parent ? this.$.$shm_projects_data.record( parent ) : null
		}

		project_type( id: string ) {
			return this.$.$shm_projects_data.record( id )?.type ?? 'complex'
		}

		project_roots() {
			const visible = new Set( this.projects_filtered().map( project => project.id ) )
			return this.projects_filtered()
				.filter( project => !project.parent_id || !visible.has( project.parent_id ) )
				.map( project => project.id )
		}

		project_children( id: string ) {
			return this.projects_filtered().filter( project => project.parent_id === id ).map( project => project.id )
		}

		@ $mol_mem_key
		override project_expanded( id: string, next?: boolean ) {
			if( this.filter() ) return true
			return this.$.$mol_state_local.value( `shm_projects:catalog:expanded:${ id }`, next ) ?? true
		}

		@ $mol_action
		override add( next?: Event ) {
			if( next === undefined ) return null
			this.new_project_opened( true )
			return next
		}

		new_project_create_enabled() {
			return Boolean( this.new_project_title().trim() )
		}

		@ $mol_action
		override new_project_cancel( next?: Event ) {
			if( next === undefined ) return null
			this.new_project_title( '' )
			this.new_project_opened( false )
			return next
		}

		@ $mol_action
		override new_project_create( next?: Event ) {
			if( next === undefined ) return null
			const title = this.new_project_title().trim()
			if( !title ) return next
			const created = $mol_wire_sync( $shm_projects_goal_api ).project_create( title )
			this.$.$shm_projects_data.records( created.projects )
			this.new_project_title( '' )
			this.new_project_opened( false )
			this.$.$mol_state_arg.value( 'project', created.project.id )
			this.$.$mol_state_arg.value( 'project_tab', 'development' )
			this.$.$mol_state_arg.value( 'project_preview', null )
			this.$.$mol_state_arg.value( 'project_version', null )
			return next
		}

		project_title( id: string ) {
			return this.$.$shm_projects_data.record( id )?.title ?? id
		}

		project_current( id: string ) {
			return this.project_selected() === id
		}

		project_arg( id: string ) {
			return {
				project: id,
				project_tab: 'development',
				project_preview: null,
				project_version: null,
				project_version_output: null,
				project_task: null,
				goal_run: null,
				session: null,
			}
		}

		catalog_pages() {
			const project = this.project_selected()
			const details = this.new_project_opened()
				? [ this.New_project_page() ]
				: project ? this.Project( project ).pages_deep() : []
			return this.projects_list_visible()
				? [ this.Menu_page(), ...details ]
				: details
		}

	}

}
